import { useState } from 'react';
import Modal from '../../../components/feature/Modal';

export default function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const handleServiceClick = (service: string) => {
    const serviceMap: Record<string, string> = {
      '네일아트': '/service/nail',
      '속눈썹': '/service/lash',
      '왁싱': '/service/waxing',
      '피부관리': '/service/skincare',
      '헤어': '/service/hair',
      '메이크업': '/service/makeup',
    };
    
    const path = serviceMap[service];
    if (path) {
      window.location.href = path;
    }
  };

  const closeModal = () => setActiveModal(null);

  return (
    <>
      <footer className="bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 pt-20 pb-8 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-2 mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/c28ff5f2-f935-4109-b850-acfb005aa63a.png" 
                  alt="다움 뷰티 로고" 
                  className="h-10 w-auto object-contain"
                />
              </div>
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                다움 뷰티는 네일, 속눈썹, 왁싱, 피부관리 등<br />
                다양한 뷰티 서비스를 간편하게 예약할 수 있는<br />
                프리미엄 뷰티 플랫폼입니다.
              </p>
              <div className="flex items-center space-x-4">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-gradient-to-br hover:from-rose-400 hover:to-pink-400 text-gray-600 hover:text-white transition-all cursor-pointer"
                >
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-gradient-to-br hover:from-rose-400 hover:to-pink-400 text-gray-600 hover:text-white transition-all cursor-pointer"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-gradient-to-br hover:from-rose-400 hover:to-pink-400 text-gray-600 hover:text-white transition-all cursor-pointer"
                >
                  <i className="ri-youtube-fill text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-base font-medium text-gray-800 mb-4">서비스</h4>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => handleServiceClick('네일아트')}
                    className="text-sm text-gray-600 hover:text-rose-400 transition-colors cursor-pointer text-left"
                  >
                    네일아트
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handleServiceClick('속눈썹')}
                    className="text-sm text-gray-600 hover:text-rose-400 transition-colors cursor-pointer text-left"
                  >
                    속눈썹
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handleServiceClick('왁싱')}
                    className="text-sm text-gray-600 hover:text-rose-400 transition-colors cursor-pointer text-left"
                  >
                    왁싱
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handleServiceClick('피부관리')}
                    className="text-sm text-gray-600 hover:text-rose-400 transition-colors cursor-pointer text-left"
                  >
                    피부관리
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handleServiceClick('헤어')}
                    className="text-sm text-gray-600 hover:text-rose-400 transition-colors cursor-pointer text-left"
                  >
                    헤어
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handleServiceClick('메이크업')}
                    className="text-sm text-gray-600 hover:text-rose-400 transition-colors cursor-pointer text-left"
                  >
                    메이크업
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-base font-medium text-gray-800 mb-4">고객지원</h4>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => setActiveModal('terms')}
                    className="text-sm text-gray-600 hover:text-rose-400 transition-colors cursor-pointer text-left"
                  >
                    이용약관
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveModal('privacy')}
                    className="text-sm text-gray-600 hover:text-rose-400 transition-colors cursor-pointer text-left"
                  >
                    개인정보처리방침
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveModal('faq')}
                    className="text-sm text-gray-600 hover:text-rose-400 transition-colors cursor-pointer text-left"
                  >
                    자주 묻는 질문
                  </button>
                </li>
                <li>
                  <a href="mailto:support@daumbeauty.com" className="text-sm text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                    고객센터
                  </a>
                </li>
                <li>
                  <span className="text-sm text-gray-600">support@daumbeauty.com</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
              <p className="text-sm text-gray-500">
                © 2025 다움 뷰티. All rights reserved.
              </p>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-gray-500 hover:text-rose-400 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* 이용약관 모달 */}
      <Modal isOpen={activeModal === 'terms'} onClose={closeModal} title="이용약관">
        <div className="space-y-6 text-sm text-gray-600 leading-relaxed">
          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">제1조 (목적)</h3>
            <p>
              본 약관은 다움 뷰티(이하 "회사")가 제공하는 뷰티 서비스 예약 플랫폼 및 관련 제반 서비스의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">제2조 (정의)</h3>
            <ul className="space-y-2 list-disc list-inside">
              <li>"서비스"란 회사가 제공하는 뷰티 서비스 예약 플랫폼 및 관련 제반 서비스를 의미합니다.</li>
              <li>"회원"이란 본 약관에 동의하고 회사와 서비스 이용계약을 체결한 자를 말합니다.</li>
              <li>"파트너"란 회사의 플랫폼을 통해 뷰티 서비스를 제공하는 사업자를 의미합니다.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">제3조 (약관의 효력 및 변경)</h3>
            <p>
              본 약관은 서비스를 이용하고자 하는 모든 회원에 대하여 그 효력을 발생합니다. 회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 본 약관을 변경할 수 있으며, 변경된 약관은 공지사항을 통해 공지합니다.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">제4조 (서비스의 제공)</h3>
            <p>
              회사는 다음과 같은 서비스를 제공합니다:
            </p>
            <ul className="space-y-2 list-disc list-inside mt-2">
              <li>네일아트, 속눈썹, 왁싱, 피부관리, 헤어, 메이크업 등 뷰티 서비스 예약</li>
              <li>파트너 정보 제공 및 검색</li>
              <li>예약 관리 및 알림 서비스</li>
              <li>커뮤니티 및 포트폴리오 공유</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">제5조 (회원의 의무)</h3>
            <p>
              회원은 서비스 이용 시 다음 각 호의 행위를 하여서는 안 됩니다:
            </p>
            <ul className="space-y-2 list-disc list-inside mt-2">
              <li>타인의 정보 도용</li>
              <li>회사가 게시한 정보의 변경</li>
              <li>회사가 정한 정보 이외의 정보 등의 송신 또는 게시</li>
              <li>회사 및 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
              <li>회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
            </ul>
          </section>
        </div>
      </Modal>

      {/* 개인정보처리방침 모달 */}
      <Modal isOpen={activeModal === 'privacy'} onClose={closeModal} title="개인정보처리방침">
        <div className="space-y-6 text-sm text-gray-600 leading-relaxed">
          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">1. 개인정보의 수집 및 이용 목적</h3>
            <p>
              다움 뷰티는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
            </p>
            <ul className="space-y-2 list-disc list-inside mt-2">
              <li>서비스 제공 및 예약 관리</li>
              <li>회원 관리 및 본인 확인</li>
              <li>서비스 개선 및 신규 서비스 개발</li>
              <li>마케팅 및 광고 활용</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">2. 수집하는 개인정보의 항목</h3>
            <p className="mb-2">회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다:</p>
            <div className="space-y-3">
              <div>
                <strong className="text-gray-800">필수 항목:</strong>
                <p>이름, 휴대전화번호, 이메일 주소</p>
              </div>
              <div>
                <strong className="text-gray-800">선택 항목:</strong>
                <p>생년월일, 성별, 주소, 선호 서비스 정보</p>
              </div>
              <div>
                <strong className="text-gray-800">자동 수집 항목:</strong>
                <p>IP 주소, 쿠키, 서비스 이용 기록, 접속 로그</p>
              </div>
            </div>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">3. 개인정보의 보유 및 이용 기간</h3>
            <p>
              회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
            </p>
            <ul className="space-y-2 list-disc list-inside mt-2">
              <li>회원 탈퇴 시까지 (단, 관계 법령에 따라 보존할 필요가 있는 경우 해당 기간 동안 보관)</li>
              <li>계약 또는 청약철회 등에 관한 기록: 5년</li>
              <li>대금결제 및 재화 등의 공급에 관한 기록: 5년</li>
              <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">4. 개인정보의 제3자 제공</h3>
            <p>
              회사는 원칙적으로 이용자의 개인정보를 제1조에서 명시한 범위 내에서 처리하며, 이용자의 사전 동의 없이는 본래의 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다:
            </p>
            <ul className="space-y-2 list-disc list-inside mt-2">
              <li>이용자가 사전에 동의한 경우</li>
              <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">5. 정보주체의 권리·의무 및 행사방법</h3>
            <p>
              정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다:
            </p>
            <ul className="space-y-2 list-disc list-inside mt-2">
              <li>개인정보 열람 요구</li>
              <li>오류 등이 있을 경우 정정 요구</li>
              <li>삭제 요구</li>
              <li>처리정지 요구</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-800 mb-3">6. 개인정보 보호책임자</h3>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p><strong className="text-gray-800">담당부서:</strong> 고객지원팀</p>
              <p><strong className="text-gray-800">이메일:</strong> support@daumbeauty.com</p>
              <p className="mt-2 text-xs">
                정보주체는 개인정보 침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.
              </p>
            </div>
          </section>
        </div>
      </Modal>

      {/* 자주 묻는 질문 모달 */}
      <Modal isOpen={activeModal === 'faq'} onClose={closeModal} title="자주 묻는 질문">
        <div className="space-y-6">
          <div className="border-b border-gray-100 pb-6">
            <h3 className="text-base font-semibold text-gray-800 mb-2 flex items-start">
              <span className="w-6 h-6 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-400 text-white rounded-full text-xs mr-3 flex-shrink-0 mt-0.5">Q</span>
              예약은 어떻게 하나요?
            </h3>
            <p className="text-sm text-gray-600 ml-9 leading-relaxed">
              상단 메뉴의 '예약하기' 버튼을 클릭하거나, 원하시는 서비스 카테고리를 선택한 후 매장을 선택하여 예약하실 수 있습니다. 예약 시 원하시는 날짜와 시간을 선택하고, 필요한 정보를 입력하시면 됩니다.
            </p>
          </div>

          <div className="border-b border-gray-100 pb-6">
            <h3 className="text-base font-semibold text-gray-800 mb-2 flex items-start">
              <span className="w-6 h-6 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-400 text-white rounded-full text-xs mr-3 flex-shrink-0 mt-0.5">Q</span>
              예약 취소 및 변경은 어떻게 하나요?
            </h3>
            <p className="text-sm text-gray-600 ml-9 leading-relaxed">
              예약 취소 및 변경은 예약 시간 24시간 전까지 가능합니다. 마이페이지에서 예약 내역을 확인하신 후 취소 또는 변경하실 수 있습니다. 24시간 이내 취소 시에는 취소 수수료가 발생할 수 있습니다.
            </p>
          </div>

          <div className="border-b border-gray-100 pb-6">
            <h3 className="text-base font-semibold text-gray-800 mb-2 flex items-start">
              <span className="w-6 h-6 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-400 text-white rounded-full text-xs mr-3 flex-shrink-0 mt-0.5">Q</span>
              결제 방법은 어떤 것들이 있나요?
            </h3>
            <p className="text-sm text-gray-600 ml-9 leading-relaxed">
              신용카드, 체크카드, 계좌이체, 간편결제(카카오페이, 네이버페이 등) 등 다양한 결제 방법을 지원합니다. 일부 매장에서는 현장 결제도 가능하니, 예약 시 확인해 주세요.
            </p>
          </div>

          <div className="border-b border-gray-100 pb-6">
            <h3 className="text-base font-semibold text-gray-800 mb-2 flex items-start">
              <span className="w-6 h-6 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-400 text-white rounded-full text-xs mr-3 flex-shrink-0 mt-0.5">Q</span>
              서비스 시간은 얼마나 걸리나요?
            </h3>
            <p className="text-sm text-gray-600 ml-9 leading-relaxed">
              서비스 종류에 따라 소요 시간이 다릅니다. 네일아트는 약 1-2시간, 속눈썹은 1-1.5시간, 왁싱은 30분-1시간, 피부관리는 1-2시간 정도 소요됩니다. 정확한 시간은 각 서비스 상세 페이지에서 확인하실 수 있습니다.
            </p>
          </div>

          <div className="border-b border-gray-100 pb-6">
            <h3 className="text-base font-semibold text-gray-800 mb-2 flex items-start">
              <span className="w-6 h-6 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-400 text-white rounded-full text-xs mr-3 flex-shrink-0 mt-0.5">Q</span>
              첫 방문 고객 할인이 있나요?
            </h3>
            <p className="text-sm text-gray-600 ml-9 leading-relaxed">
              네, 대부분의 파트너 매장에서 첫 방문 고객을 위한 특별 할인을 제공하고 있습니다. 각 매장의 프로모션 정보는 매장 상세 페이지에서 확인하실 수 있으며, 예약 시 자동으로 적용됩니다.
            </p>
          </div>

          <div className="border-b border-gray-100 pb-6">
            <h3 className="text-base font-semibold text-gray-800 mb-2 flex items-start">
              <span className="w-6 h-6 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-400 text-white rounded-full text-xs mr-3 flex-shrink-0 mt-0.5">Q</span>
              리뷰는 어떻게 작성하나요?
            </h3>
            <p className="text-sm text-gray-600 ml-9 leading-relaxed">
              서비스 이용 후 마이페이지의 예약 내역에서 리뷰를 작성하실 수 있습니다. 솔직한 리뷰는 다른 고객들에게 큰 도움이 되며, 리뷰 작성 시 포인트 적립 혜택도 제공됩니다.
            </p>
          </div>

          <div className="pb-2">
            <h3 className="text-base font-semibold text-gray-800 mb-2 flex items-start">
              <span className="w-6 h-6 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-400 text-white rounded-full text-xs mr-3 flex-shrink-0 mt-0.5">Q</span>
              문의사항이 있을 때는 어떻게 하나요?
            </h3>
            <p className="text-sm text-gray-600 ml-9 leading-relaxed">
              고객센터 이메일(support@daumbeauty.com)로 문의하시거나, 각 매장에 직접 연락하실 수 있습니다. 평일 오전 9시부터 오후 6시까지 운영되며, 빠른 시일 내에 답변 드리겠습니다.
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
}
